/**
 * Sucursal donde está la regente (2026-09-30). La elige al entrar; queda en
 * localStorage de la tablet y viaja en cada POST /chat (id_und_neg). Define el
 * stock y los equivalentes que muestra la tarjeta.
 */
export interface SucursalElegida {
  id_und_neg: number
  nombre: string
}

const KEY = 'sucursal_hipermaxi'

export function leerSucursal(): SucursalElegida | null {
  try {
    const raw = localStorage.getItem(KEY)
    if (!raw) return null
    const s = JSON.parse(raw) as SucursalElegida
    return typeof s?.id_und_neg === 'number' ? s : null
  } catch {
    return null
  }
}

export function guardarSucursal(s: SucursalElegida): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(s))
  } catch {
    /* sin storage: la sucursal vale solo para esta sesión */
  }
}

export function olvidarSucursal(): void {
  try {
    localStorage.removeItem(KEY)
  } catch {
    /* noop */
  }
}
